/* STH Bazaar Animations v2 — scroll stagger + collection body class */
(function(){
  'use strict';

  /* 1. Add collection-{handle} class to body for category atmospheres (4K) */
  var colMatch = window.location.pathname.match(/\/collections\/([^\/\?#]+)/);
  if (colMatch) {
    document.body.classList.add('collection-' + colMatch[1].replace(/[^a-z0-9-]/gi, '-').toLowerCase());
  }

  /* 2. Scroll-triggered stagger reveal for product cards */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Inject CSS only via JS — no JS = no opacity:0 = always visible */
  var style = document.createElement('style');
  style.textContent = [
    '.sth-anim { opacity: 0; transform: translateY(14px); transition: opacity .36s ease, transform .36s ease; }',
    '.sth-anim.sth-vis { opacity: 1 !important; transform: none !important; }'
  ].join('');
  document.head.appendChild(style);

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('sth-vis');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -20px 0px', threshold: 0.05 });

  var SELECTOR = '.card-wrapper, .sth-hero__card, .sth-flash__card, .sth-daily__card';

  function initStagger() {
    var cards = document.querySelectorAll(SELECTOR);
    var delay = 0;
    cards.forEach(function(el, i) {
      if (el.dataset.sthA) return;
      el.dataset.sthA = '1';
      /* stagger delay: 0–4 cards per row, 55ms apart, then reset */
      delay = Math.min(i % 5, 4) * 55;
      el.style.transitionDelay = delay + 'ms';
      el.classList.add('sth-anim');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initStagger();
      setTimeout(initStagger, 1400);
    });
  } else {
    initStagger();
    setTimeout(initStagger, 1400);
  }

})();
